import { render, staticRenderFns } from "./CollaboratorFormModal.vue?vue&type=template&id=b3c5b4e8&"
import script from "./CollaboratorFormModal.vue?vue&type=script&lang=js&"
export * from "./CollaboratorFormModal.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorFormModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports